function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import { SmartNav } from 'module-tsl-ui-smart-nav';

var ElementsSubjectsMobile = /*#__PURE__*/function (_React$Component) {
  _inherits(ElementsSubjectsMobile, _React$Component);

  var _super = _createSuper(ElementsSubjectsMobile);

  function ElementsSubjectsMobile(props) {
    var _this;

    _classCallCheck(this, ElementsSubjectsMobile);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getMenu", function (elementsSubjects, topics, allSubTopics) {
      var uniqueSubjectLabels = _this.getUniqueSubjectLabels(elementsSubjects);

      var menuWithSubjects = _this.fillWithSubjects(uniqueSubjectLabels);

      var menuWithSubjectsAndTopics = _this.fillWithTopics(elementsSubjects, topics, menuWithSubjects);

      var menu = _this.fillWithSubTopics(elementsSubjects, topics, allSubTopics, menuWithSubjectsAndTopics);

      return menu;
    });

    _defineProperty(_assertThisInitialized(_this), "getUniqueSubjectLabels", function (elementsSubjects) {
      var subjectLabels = elementsSubjects.map(function (_ref) {
        var title = _ref.title;
        return title;
      });
      return _toConsumableArray(new Set(subjectLabels));
    });

    _defineProperty(_assertThisInitialized(_this), "getCheckedItems", function (activeSubTopics, activeTopicTitle) {
      if (!!activeSubTopics && activeSubTopics.length > 0) return activeSubTopics;
      if (activeTopicTitle) return [activeTopicTitle];
      return [];
    });

    _defineProperty(_assertThisInitialized(_this), "getBreadCrumbs", function (menu, activeTopicTitle) {
      if (!activeTopicTitle || activeTopicTitle === 'topics-all') return [];

      var _find = find(menu, function (_ref2) {
        var children = _ref2.children;
        return children.some(function (_ref3) {
          var transformedName = _ref3.transformedName;
          return transformedName === activeTopicTitle;
        });
      }),
          activeSubject = _find.transformedName,
          subjectChildren = _find.children;

      var _find2 = find(subjectChildren, function (_ref4) {
        var transformedName = _ref4.transformedName;
        return transformedName === activeTopicTitle;
      }),
          children = _find2.children;

      return !children || !children.length ? [activeSubject] : [activeSubject, activeTopicTitle];
    });

    _defineProperty(_assertThisInitialized(_this), "transform", function (stringToTransform) {
      return stringToTransform.trim().toLowerCase().replace(/ /g, '-').replace(/&/g, 'and').replace(/'/g, '').replace(/,/g, '');
    });

    _defineProperty(_assertThisInitialized(_this), "fillWithSubjects", function (uniqueSubjectLabels) {
      return uniqueSubjectLabels.map(function (label) {
        return {
          label: label,
          transformedName: _this.transform(label),
          children: [],
          radio: true
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fillWithTopics", function (allSubjects, allTopics, menu) {
      var menuSoFar = _toConsumableArray(menu);

      allTopics.forEach(function (_ref5) {
        var topicTitle = _ref5.title,
            parentName = _ref5.parentName;

        var _find3 = find(allSubjects, function (_ref6) {
          var name = _ref6.name;
          return name === parentName;
        }),
            subjectTitle = _find3.title;

        var indexOfSubjectMenuItem = findIndex(menuSoFar, function (_ref7) {
          var label = _ref7.label;
          return label === subjectTitle;
        });
        var topic = {
          label: topicTitle,
          transformedName: _this.transform(topicTitle)
        };

        if (!find(menuSoFar[indexOfSubjectMenuItem].children, function (_ref8) {
          var label = _ref8.label;
          return label === topicTitle;
        })) {
          menuSoFar[indexOfSubjectMenuItem].children.push(topic);
        }
      });
      return menuSoFar;
    });

    _defineProperty(_assertThisInitialized(_this), "fillWithSubTopics", function (allSubjects, allTopics, allSubTopics, menuSoFar) {
      var menu = _toConsumableArray(menuSoFar);

      allSubTopics.forEach(function (_ref9) {
        var id = _ref9.id,
            parents = _ref9.parents,
            text = _ref9.text;
        var newSubTopicMenuItem = {
          label: text,
          transformedName: id
        };
        var parentId = (Array.isArray(parents) ? parents : parents.split(','))[0];

        var _find4 = find(allTopics, function (_ref10) {
          var name = _ref10.name;
          return name === parentId;
        }),
            topicTitle = _find4.title,
            topicParentName = _find4.parentName;

        var _find5 = find(allSubjects, function (_ref11) {
          var name = _ref11.name;
          return name === topicParentName;
        }),
            subjectTitle = _find5.title;

        var indexOfSubjectMenuItem = findIndex(menu, function (_ref12) {
          var label = _ref12.label;
          return label === subjectTitle;
        });
        var indexOfTopicMenuItem = findIndex(menu[indexOfSubjectMenuItem].children, function (_ref13) {
          var label = _ref13.label;
          return label === topicTitle;
        });
        var children = menu[indexOfSubjectMenuItem].children[indexOfTopicMenuItem].children || [];
        children.push(newSubTopicMenuItem);
        menu[indexOfSubjectMenuItem].children[indexOfTopicMenuItem].children = children;
      });
      return menu;
    });

    _defineProperty(_assertThisInitialized(_this), "updateUrl", function (currentUrl, key, newValue) {
      var newValueString = !newValue ? '' : "&".concat(key, "=").concat(newValue);
      return currentUrl.replace(new RegExp("([?&]".concat(key, "(?=[=&#]|$)[^#&]*|(?=#|$))")), newValueString).replace(/^([^?&]+)&/, '$1?');
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(ElementsSubjectsMobile, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          elementsSubjects = _this$props.elementsSubjects,
          topics = _this$props.topics,
          allSubTopics = _this$props.allSubTopics,
          activeSubTopics = _this$props.activeSubTopics,
          activeTopicTitle = _this$props.activeTopicTitle;
      var menu = this.getMenu(elementsSubjects, topics, allSubTopics);
      return /*#__PURE__*/React.createElement("div", {
        className: "elements__mobile-btn"
      }, /*#__PURE__*/React.createElement(SmartNav, {
        theme: "purple",
        menu: menu,
        initialTitle: "Topics",
        resetAll: "All elements",
        itemKey: "transformedName",
        checkedItems: this.getCheckedItems(activeSubTopics, activeTopicTitle),
        breadCrumbs: this.getBreadCrumbs(menu, activeTopicTitle),
        onDone: function onDone(checkedItems) {
          if (!checkedItems || !checkedItems.length) {
            var updatedUrl = _this2.updateUrl("".concat(window.location.origin, "/teaching-resources/hub/elements").concat(window.location.search), 'subtopics', '');

            return window.location.replace(updatedUrl);
          }

          if (checkedItems[0].ancestors.length > 1) {
            var subject = checkedItems[0].ancestors[0].transformedName;
            var topic = checkedItems[0].ancestors[1].transformedName;
            var subTopics = checkedItems.map(function (_ref14) {
              var transformedName = _ref14.transformedName;
              return transformedName;
            }).join();

            var _newUrl = "".concat(window.location.origin, "/teaching-resources/hub/elements/").concat(subject, "/").concat(topic).concat(window.location.search);

            var _url = includes(['phonics', 'spag', 'comprehension'], subject) ? _this2.updateUrl(_newUrl, 'stage', '') : _newUrl;

            return window.location.replace(_this2.updateUrl(_url, 'subtopics', subTopics));
          }

          var selectedSubject = checkedItems[0].ancestors[0].transformedName;
          var selectedTopic = checkedItems[0].transformedName;
          var newUrl = "".concat(window.location.origin, "/teaching-resources/hub/elements/").concat(selectedSubject, "/").concat(selectedTopic);
          var url = includes(['phonics', 'spag', 'comprehension'], selectedSubject) ? _this2.updateUrl(newUrl, 'stage', '') : newUrl;
          return window.location.replace(url);
        }
      }));
    }
  }]);

  return ElementsSubjectsMobile;
}(React.Component);

ElementsSubjectsMobile.displayName = "ElementsSubjectsMobile";
ElementsSubjectsMobile.propTypes = {
  elementsSubjects: PropTypes.arrayOf(PropTypes.object).isRequired,
  topics: PropTypes.arrayOf(PropTypes.object).isRequired,
  allSubTopics: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeSubTopics: PropTypes.arrayOf(PropTypes.string),
  activeTopicTitle: PropTypes.string
};
export default ElementsSubjectsMobile;